import { useState, useEffect } from 'react';
export var useCloudNetworkStatus = function useCloudNetworkStatus() {
  var _useState = useState(typeof navigator !== 'undefined' ? navigator.onLine : true),
    isOnline = _useState[0],
    setIsOnline = _useState[1];
  useEffect(function () {
    var handleNetworkChange = function handleNetworkChange() {
      var _navigator$onLine, _navigator;
      setIsOnline((_navigator$onLine = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.onLine) !== null && _navigator$onLine !== void 0 ? _navigator$onLine : true);
    };
    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);
    handleNetworkChange();
    return function () {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, []);
  return isOnline;
};
export default useCloudNetworkStatus;